import React, { useState, useEffect, useContext } from "react";
import qs from 'query-string'

import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import { AuthContext } from "../../context/Auth/AuthContext";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import usePlans from '../../hooks/usePlans';
import { i18n } from "../../translate/i18n";
import { FormControl } from "@material-ui/core";
import { InputLabel, MenuItem, Select } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import useSettings from "../../hooks/useSettings";
import CountryPhoneSelector from "../../components/CountryPhoneSelector";
import CongratulationsModal from "../../components/CongratulationsModal";
import PublicLogo from "../../components/PublicLogo";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    // Root da página - layout de duas colunas
    root: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    // Coluna esquerda - Formulário
    leftColumn: {
        flex: "0 0 50%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px",
        backgroundColor: theme.palette.type === 'dark' ? "#1a1a1a" : "#ffffff",
        overflowY: "auto",
        [theme.breakpoints.down('md')]: {
            flex: "1 1 100%",
            padding: "20px",
        },
    },
    // Coluna direita - Imagem promocional
    rightColumn: {
        flex: "0 0 50%",
        background: `linear-gradient(135deg, #667eea 0%, #764ba2 100%)`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "60px 40px",
        position: "relative",
        overflow: "hidden",
        [theme.breakpoints.down('md')]: {
            display: "none",
        },
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)",
            pointerEvents: "none",
        }
    },
    // Container do formulário
    formContainer: {
        width: "100%",
        maxWidth: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    // Logo/Avatar
    logoContainer: {
        marginBottom: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        width: "64px",
        height: "64px",
        backgroundColor: "#667eea",
        marginBottom: "16px",
        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
        "& .MuiSvgIcon-root": {
            fontSize: "2rem",
            color: "#ffffff",
        }
    },
    title: {
        fontSize: "28px",
        fontWeight: 700,
        color: theme.palette.type === 'dark' ? "#ffffff" : "#1a1a1a",
        marginBottom: "8px",
        textAlign: "center",
    },
    subtitle: {
        fontSize: "16px",
        color: theme.palette.type === 'dark' ? "#b0b0b0" : "#666666",
        marginBottom: "32px",
        textAlign: "center",
        lineHeight: 1.5,
    },
    form: {
        width: "100%",
        "& .MuiTextField-root": {
            marginBottom: "20px",
            "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: theme.palette.type === 'dark' ? "#2a2a2a" : "#f8f9fa",
                border: theme.palette.type === 'dark' ? "1px solid #404040" : "1px solid #e9ecef",
                transition: "all 0.2s ease",
                "&:hover": {
                    borderColor: theme.palette.type === 'dark' ? "#606060" : "#ced4da",
                },
                "&.Mui-focused": {
                    backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#ffffff",
                    borderColor: "#667eea",
                    boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                }
            },
            "& .MuiInputLabel-root": {
                color: theme.palette.type === 'dark' ? "#b0b0b0" : "#666666",
                fontSize: "14px",
                "&.Mui-focused": {
                    color: "#667eea",
                }
            }
        },
        "& .MuiFormControl-root": {
            marginBottom: "20px",
            "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: theme.palette.type === 'dark' ? "#2a2a2a" : "#f8f9fa",
                border: theme.palette.type === 'dark' ? "1px solid #404040" : "1px solid #e9ecef",
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                }
            }
        }
    },
    submit: {
        width: "100%",
        height: "48px",
        borderRadius: "8px",
        backgroundColor: "#667eea",
        color: "#ffffff",
        fontSize: "16px",
        fontWeight: 600,
        textTransform: "none",
        marginTop: "24px",
        marginBottom: "16px",
        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: "#5a6fd8",
            transform: "translateY(-1px)",
            boxShadow: "0 6px 16px rgba(102, 126, 234, 0.4)",
        },
        "&:active": {
            transform: "translateY(0)",
        },
        "&:disabled": {
            backgroundColor: "#cccccc",
            color: "#666666",
        }
    },
    linkContainer: {
        textAlign: "center",
        marginTop: "16px",
        "& .MuiLink-root": {
            color: "#667eea",
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: 500,
            "&:hover": {
                textDecoration: "underline",
            }
        }
    },
    // Estilos para a coluna direita
    promoContent: {
        color: "#ffffff",
        textAlign: "center",
        zIndex: 1,
        position: "relative",
    },
    promoTitle: {
        fontSize: "32px",
        fontWeight: 700,
        marginBottom: "16px",
        lineHeight: 1.2,
    },
    promoSubtitle: {
        fontSize: "18px",
        marginBottom: "32px",
        opacity: 0.9,
        lineHeight: 1.5,
    },
    promoFeatures: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        "& li": {
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
            fontSize: "16px",
            "&::before": {
                content: '"✓"',
                marginRight: "12px",
                width: "20px",
                height: "20px",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px",
                fontWeight: "bold",
            }
        }
    }
}));

const UserSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    companyName: Yup.string()
        .min(2, i18n.t('validation.tooShort'))
        .max(50, i18n.t('validation.tooLong'))
        .required(i18n.t('validation.required')),
    password: Yup.string().min(5, i18n.t('validation.tooShort')).max(50, i18n.t('validation.tooLong')),
    email: Yup.string().email(i18n.t('validation.invalidEmail')).required(i18n.t('validation.required')),
    phone: Yup.string().required(i18n.t('validation.required')),
});

const SignUp = () => {
    const classes = useStyles();
    const history = useHistory();
    const { handleLogin } = useContext(AuthContext);
    const { getPlanList } = usePlans()
    const [plans, setPlans] = useState([])
    const [loading, setLoading] = useState(false);
    const { getPublicSetting } = useSettings();

    let companyId = null
    const params = qs.parse(window.location.search)
    if (params.companyId !== undefined) {
        companyId = params.companyId
    }

    const initialState = { name: "", email: "", password: "", phone: "", companyId, companyName: "", planId: "" };

    const [user, setUser] = useState(initialState);
    const [showCongratulations, setShowCongratulations] = useState(false);
    const [registeredCompanyName, setRegisteredCompanyName] = useState("");

    useEffect(() => {
        getPublicSetting("userCreation")
            .then((data) => {
                if (data === "disabled") {
                    toast.error(i18n.t("signup.toasts.disabled"));
                    history.push("/login");
                }
            })
            .catch((error) => {
                console.log("Error reading setting", error);
            });
    }, []);

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            const planList = await getPlanList({ listPublic: "false" });

            setPlans(planList);
            // Automaticamente selecionar o primeiro plano disponível
            if (planList && planList.length > 0) {
                setUser(prevUser => ({ ...prevUser, planId: planList[0].id }));
            }
            setLoading(false);
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);







    const handleSignUp = async values => {
        try {
            await openApi.post("/auth/signup", values);
            
            // Guardar el nombre de la empresa y mostrar modal de felicitaciones
            setRegisteredCompanyName(values.companyName);
            setShowCongratulations(true);
            
            // Mostrar toast de éxito también
            toast.success(i18n.t("signup.toasts.success"));
            
        } catch (err) {
            toastError(err);
        }
    };

    const handleCongratulationsClose = async () => {
        setShowCongratulations(false);
        
        // Realizar login automático después de cerrar el modal
        try {
            await handleLogin({
                email: user.email,
                password: user.password
            });
            // O handleLogin já redireciona para a página principal após login bem-sucedido
        } catch (loginErr) {
            // Se o login automático falhar, redireciona para a página de login
            console.error("Auto-login failed:", loginErr);
            history.push("/login");
        }
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            
            {/* Coluna Esquerda - Formulário */}
            <div className={classes.leftColumn}>
                <div className={classes.formContainer}>
                    {/* Logo e Título */}
                    <div className={classes.logoContainer}>
                        <PublicLogo 
                            style={{
                                width: "120px",
                                height: "auto",
                                marginBottom: "16px"
                            }}
                        />
                        <Typography className={classes.title}>
                            {i18n.t("signup.title")}
                        </Typography>
                        <Typography className={classes.subtitle}>
                            {i18n.t("signup.subtitle")}
                        </Typography>
                    </div>

                    {/* Formulário */}
                    <Formik
                        initialValues={user}
                        enableReinitialize={true}
                        validationSchema={UserSchema}
                        onSubmit={(values, actions) => {
                            const submitValues = {
                                ...values,
                                planId: values.planId || (plans[0]?.id || "")
                            };
                            setTimeout(() => {
                                handleSignUp(submitValues);
                                actions.setSubmitting(false);
                            }, 400);
                        }}
                    >
                        {({ touched, errors, isSubmitting, setFieldValue }) => (
                            <Form className={classes.form}>
                                <Field
                                    as={TextField}
                                    variant="outlined"
                                    fullWidth
                                    id="companyName"
                                    label={i18n.t("signup.form.company")}
                                    error={touched.companyName && Boolean(errors.companyName)}
                                    helperText={touched.companyName && errors.companyName}
                                    name="companyName"
                                    autoComplete="companyName"
                                    autoFocus
                                />

                                <Field
                                    as={TextField}
                                    autoComplete="name"
                                    name="name"
                                    error={touched.name && Boolean(errors.name)}
                                    helperText={touched.name && errors.name}
                                    variant="outlined"
                                    fullWidth
                                    id="name"
                                    label={i18n.t("signup.form.name")}
                                />

                                <Field
                                    as={TextField}
                                    variant="outlined"
                                    fullWidth
                                    id="email"
                                    label={i18n.t("signup.form.email")}
                                    name="email"
                                    error={touched.email && Boolean(errors.email)}
                                    helperText={touched.email && errors.email}
                                    autoComplete="email"
                                    inputProps={{ style: { textTransform: 'lowercase' } }}
                                />

                                <CountryPhoneSelector
                                    value={user.phone}
                                    onChange={(phone) => {
                                        setUser(prevUser => ({ ...prevUser, phone }));
                                        setFieldValue('phone', phone);
                                    }}
                                    error={touched.phone && Boolean(errors.phone)}
                                    helperText={touched.phone && errors.phone}
                                />

                                <Field
                                    as={TextField}
                                    variant="outlined"
                                    fullWidth
                                    name="password"
                                    label={i18n.t("signup.form.password")}
                                    type="password"
                                    id="password"
                                    error={touched.password && Boolean(errors.password)}
                                    helperText={touched.password && errors.password}
                                    autoComplete="current-password"
                                />

                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel id="plan-select-label">
                                        {i18n.t("signup.form.plan")}
                                    </InputLabel>
                                    <Select
                                        labelId="plan-select-label"
                                        id="plan-select"
                                        value={user.planId || ""}
                                        disabled={loading}
                                        onChange={(e) => {
                                            setUser(prevUser => ({ ...prevUser, planId: e.target.value }));
                                        }}
                                    >
                                        {loading ? (
                                            <MenuItem disabled>
                                                <CircularProgress size={20} style={{ marginRight: 8 }} />
                                                {i18n.t("signup.form.loadingPlans")}
                                            </MenuItem>
                                        ) : (
                                            plans.map((plan) => (
                                                <MenuItem key={plan.id} value={plan.id}>
                                                    {plan.name} - ${plan.amount} ({plan.recurrence === 'monthly' ? i18n.t("signup.form.monthly") : i18n.t("signup.form.annual")})
                                                    {plan.trial && plan.trialDays > 0 && (
                                                        <span style={{ color: '#4caf50', fontWeight: 'bold', marginLeft: '8px' }}>
                                                            - {plan.trialDays} {i18n.t("signup.form.freeDays")}
                                                        </span>
                                                    )}
                                                </MenuItem>
                                            ))
                                        )}
                                    </Select>
                                </FormControl>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    className={classes.submit}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Registrando..." : i18n.t("signup.buttons.submit")}
                                </Button>

                                <div className={classes.linkContainer}>
                                    <Link
                                        component={RouterLink}
                                        to="/login"
                                    >
                                        {i18n.t("signup.buttons.login")}
                                    </Link>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>

            {/* Columna Derecha - Contenido Promocional */}
            <div className={classes.rightColumn}>
                <div className={classes.promoContent}>
                    <Typography className={classes.promoTitle}>
                        {i18n.t("signup.promo.title")}
                    </Typography>
                    <Typography className={classes.promoSubtitle}>
                        {i18n.t("signup.promo.subtitle")}
                    </Typography>
                    <ul className={classes.promoFeatures}>
                        <li>{i18n.t("signup.promo.features.multichannel")}</li>
                        <li>{i18n.t("signup.promo.features.automation")}</li>
                        <li>{i18n.t("signup.promo.features.analytics")}</li>
                        <li>{i18n.t("signup.promo.features.integration")}</li>
                        <li>{i18n.t("signup.promo.features.support")}</li>
                    </ul>
                </div>
            </div>
            
            {/* Modal de felicitaciones */}
            <CongratulationsModal
                open={showCongratulations}
                onClose={handleCongratulationsClose}
                companyName={registeredCompanyName}
            />
        </div>
    );
};

export default SignUp;